<template>
  <tr>
    <!-- eslint-disable vue/no-v-html -->
    <td
      v-for="column in childColumns"
      :key="column.label"
      v-html="column.formatMethod
        ? column.formatMethod(childRowData[column.prop])
        : childRowData[column.prop]
      "
    />
    <!-- eslint-enable vue/no-v-html -->
  </tr>
</template>

<script>
  export default {
    name: 'TfTableChildRow',
    props: {
      childRowData: {
        type: Object,
        default: () => ({}),
      },
      childColumns: {
        type: Array,
        default: () => [],
      },
    },
  };
</script>
